<template>
  <sub-request-selector></sub-request-selector>
</template>

<script>
import SubRequestSelector from '../components/sub-request-selector/index.vue';

export default { components: { SubRequestSelector } };

</script>
